import Typography from '../../../../../../../components/Typography/Typography'

const VoucherOrderInfo = ({ vouchers }) => (
    <div className={'order-info d-flex flex-column'}>
        {vouchers?.map((voucher) => (
            <div key={voucher.number} className={'order-info--row d-flex justify-content-between'}>
                <Typography variant={'p'}>{voucher.name}</Typography>
                <Typography variant={'p'}>{`${voucher.price} ${voucher.currency}`}</Typography>
            </div>
        ))}
    </div>
)

export default VoucherOrderInfo
